import { createContext } from 'react';
import { UseApiTenders } from './hooks';
import { once } from 'lodash';

export const createApiTendersCtx = once(<TVars>() => createContext<UseApiTenders<TVars> | null>(null));
